<template>
  <div class="sections-container">
    <div class="modern-form">
      <v-container>
        <div v-if="loading" class="loading-container">
          <v-progress-circular
            indeterminate
            color="primary"
            size="64"
            class="loading-spinner" />
        </div>
        <v-row v-else>
          <v-col cols="12">
            <div class="info-section">
              <h2 class="section-title">Payment Processing Information</h2>
              <div class="lockable-section" :class="{ 'is-locked': !unlockedSections.payconnect }">
                <div class="fields-lockable">
                  <div class="form-row">
                    <v-text-field
                      label="Payconnect API Key"
                      v-model="form.payconnectApiKey"
                      class="line-input custom-filled"
                      dense
                      hide-details="auto" />
                    <v-text-field
                      label="Payconnect Secret"
                      v-model="form.payconnectSecret"
                      class="line-input custom-filled"
                      dense
                      hide-details="auto" />
                  </div>
                </div>
                <div class="section-lock-overlay" @click="requestUnlock('payconnect')">
                  <div class="section-lock-overlay__content">
                    <v-icon class="section-lock-overlay__icon">mdi-lock</v-icon>
                    <span class="section-lock-overlay__label">Unlock to Edit</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="info-section">
              <h2 class="section-title">Open Dental Information</h2>
              <div class="lockable-section" :class="{ 'is-locked': !unlockedSections.openDental }">
                <div class="fields-lockable">
                  <div class="form-row">
                    <v-text-field
                      label="Open Dental dev Key"
                      v-model="form.devKey"
                      class="line-input custom-filled"
                      dense
                      hide-details="auto" />
                    <v-text-field
                      label="Open Dental Api Key"
                      v-model="form.apiKey"
                      class="line-input custom-filled"
                      dense
                      hide-details="auto" />
                  </div>
                  <div class="form-row">
                    <v-text-field
                      label="Open Dental Version"
                      v-model="openDentalVersionString"
                      class="line-input custom-filled"
                      dense
                      hide-details="auto"
                      disabled />
                    <div></div>
                  </div>
                </div>
                <div class="section-lock-overlay" @click="requestUnlock('openDental')">
                  <div class="section-lock-overlay__content">
                    <v-icon class="section-lock-overlay__icon">mdi-lock</v-icon>
                    <span class="section-lock-overlay__label">Unlock to Edit</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="info-section">
              <h2 class="section-title">Mailgun Information</h2>
              <div class="lockable-section" :class="{ 'is-locked': !unlockedSections.mailgun }">
                <div class="fields-lockable">
                  <div class="form-row">
                    <v-text-field
                      label="Mailgun Api Key"
                      v-model="form.mailgunApiKey"
                      class="line-input custom-filled"
                      dense
                      hide-details="auto" />
                    <v-text-field
                      label="Mailgun Domain"
                      v-model="form.mailgunDomain"
                      class="line-input custom-filled"
                      dense
                      hide-details="auto" />
                  </div>
                  <div class="form-row">
                    <v-text-field
                      label="Mailgun Send As"
                      v-model="form.mailgunSendAs"
                      class="line-input custom-filled"
                      dense
                      hide-details="auto" />
                    <v-text-field
                      label="Mailgun Webhook Key"
                      v-model="form.mailgunWebhookKey"
                      class="line-input custom-filled"
                      dense
                      hide-details="auto" />
                  </div>
                </div>
                <div class="section-lock-overlay" @click="requestUnlock('mailgun')">
                  <div class="section-lock-overlay__content">
                    <v-icon class="section-lock-overlay__icon">mdi-lock</v-icon>
                    <span class="section-lock-overlay__label">Unlock to Edit</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="info-section">
              <h2 class="section-title">Twilio Information</h2>
              <div class="lockable-section" :class="{ 'is-locked': !unlockedSections.twilio }">
                <div class="fields-lockable">
                  <div class="form-row">
                    <v-text-field
                      label="Twilio Account SID"
                      v-model="form.twilioSID"
                      class="line-input custom-filled"
                      dense
                      hide-details="auto" />
                    <v-text-field
                      label="Twillio Auth Token"
                      v-model="form.twilioAuthToken"
                      class="line-input custom-filled"
                      dense
                      hide-details="auto" />
                  </div>
                  <div class="form-row">
                    <v-text-field
                      label="Twilio Send From"
                      v-model="form.twilioSendFrom"
                      class="line-input custom-filled"
                      dense
                      hide-details="auto" />
                    <div></div>
                  </div>
                </div>
                <div class="section-lock-overlay" @click="requestUnlock('twilio')">
                  <div class="section-lock-overlay__content">
                    <v-icon class="section-lock-overlay__icon">mdi-lock</v-icon>
                    <span class="section-lock-overlay__label">Unlock to Edit</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="info-section">
              <h2 class="section-title">Service Messages</h2>
              <div class="form-row">
                <v-text-field
                  label="Global Service Message"
                  v-model="globalServiceMessage"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
                <v-text-field
                  label="Appointment Scheduling Message"
                  v-model="schedulingMessage"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
              </div>
            </div>

            <div class="form-actions">
              <v-btn class="btn-primary" @click="saveAll">Save</v-btn>
              <v-btn class="btn-secondary" @click="cancelUpdate">Cancel</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-dialog v-model="unlockDialog" max-width="500px" persistent>
        <v-card class="modern-modal">
          <v-card-title class="modal-title">Unlock Section</v-card-title>
          <v-card-text class="modal-content">
            <p class="modal-question">This section contains sensitive integration credentials. Incorrect values will cause services to stop working. Are you sure you want to unlock it for editing?</p>
          </v-card-text>
          <v-card-actions class="modal-actions">
            <v-btn class="btn-secondary" @click="unlockDialog = false">Cancel</v-btn>
            <v-btn class="btn-primary" @click="confirmUnlock">Unlock</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="warningDialog" max-width="500px" persistent>
        <v-card class="modern-modal">
          <v-card-title class="modal-title">Warning</v-card-title>
          <v-card-text class="modal-content">
            <p class="modal-question">These credentials control critical integrations including payment processing (Payconnect), patient records (Open Dental), email delivery (Mailgun), and text messaging (Twilio). Incorrect values will cause these services to stop working.</p>
          </v-card-text>
          <v-card-actions class="modal-actions">
            <v-btn class="btn-secondary" @click="warningDialog = false">Cancel</v-btn>
            <v-btn class="btn-primary" @click="proceedWithSave">Acknowledge</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import DataService from '../../../_services/DataService';
import ValidateService from '../../../_services/ValidateService';

export default {
  name: 'CompanyConfig',
  data() {
    return {
      // form fields
      form: {
        payconnectApiKey: '',
        payconnectSecret: '',
        devKey: '',
        apiKey: '',
        mailgunApiKey: '',
        mailgunDomain: '',
        mailgunSendAs: '',
        mailgunWebhookKey: '',
        twilioSID: '',
        twilioAuthToken: '',
        twilioSendFrom: '',
      },
      originalForm: {},
      openDentalVersionString: '',
      globalServiceMessage: '',
      schedulingMessage: '',
      warningDialog: false,
      unlockDialog: false,
      pendingUnlockSection: null,
      unlockedSections: {
        payconnect: false,
        openDental: false,
        mailgun: false,
        twilio: false,
      },
      loadingClientInfo: true,
      loadingVersion: true,
      rules: ValidateService.validators,
    };
  },
  computed: {
    loading: function() {
      return this.loadingClientInfo || this.loadingVersion;
    },
  },
  methods: {
    requestUnlock(section) {
      this.pendingUnlockSection = section;
      this.unlockDialog = true;
    },
    confirmUnlock() {
      this.unlockedSections[this.pendingUnlockSection] = true;
      this.unlockDialog = false;
      this.pendingUnlockSection = null;
    },
    cancelUpdate() {
      location.reload();
    },
    async closeAndReload() {
      await this.getClientInfo();
    },
    async getClientInfo() {
      this.loadingClientInfo = true;

      const response = await DataService.getConfigInfoById(DataService.getClientId());

      if (response.status == 200 && response.data) {
        this.form = {
          payconnectApiKey: response.data.payconnectApiKey,
          payconnectSecret: response.data.payconnectSecret,
          gateWay: response.data.authNetGatewayId,
          devKey: response.data.openDentalDevKey,
          apiKey: response.data.openDentalApiKey,
          mailgunApiKey: response.data.mailgunApiKey,
          mailgunDomain: response.data.mailgunDomain,
          mailgunSendAs: response.data.mailgunSendAs,
          mailgunWebhookKey: response.data.mailgunWebhookKey,
          twilioSID: response.data.twilioAccountSid,
          twilioAuthToken: response.data.twilioAuthToken,
          twilioSendFrom: response.data.twilioSendFrom,
        };
        this.originalForm = { ...this.form };
      } else {
        this.displayError();
      }

      this.loadingClientInfo = false;
    },
    async getVersionInfo() {
      this.loadingVersion = true;

      const response = await DataService.getOpenDentalVersion(DataService.getClientId());

      if (response.status == 200 && response.data) {
        this.openDentalVersionString = response.data?.versionString;
      } else {
        this.displayError('Failed to load open dental version string');
      }

      this.loadingVersion = false;
    },
    displayError(msg) {
      let str = 'Something went wrong';

      if (msg !== undefined) str = msg;
      this.$root.$emit('raise_alert', {
        color: 'error',
        text: str,
      });
    },
    async updateClientInfo() {
      const body = {
        payconnectApiKey: this.form.payconnectApiKey,
        payconnectSecret: this.form.payconnectSecret,
        openDentalDevKey: this.form.devKey,
        openDentalApiKey: this.form.apiKey,
        mailgunApiKey: this.form.mailgunApiKey,
        mailgunDomain: this.form.mailgunDomain,
        mailgunSendAs: this.form.mailgunSendAs,
        mailgunWebhookKey: this.form.mailgunWebhookKey,
        twilioAccountSid: this.form.twilioSID,
        twilioAuthToken: this.form.twilioAuthToken,
        twilioSendFrom: this.form.twilioSendFrom,
      };

      const keyCheckResponse = await DataService.checkAuthKeys(body);
      if (keyCheckResponse.status === 200) {
        await DataService.updateConfigInfoById(DataService.getClientId(), body);
        await this.getVersionInfo();
        return true;
      } else {
        return false;
      }
    },
    async getServiceMessages() {
      const response = await DataService.getServiceMessages();

      if (response.status === 200) {
        const serviceMessages = response.data;
        this.globalServiceMessage = serviceMessages.find((message) => !message.page)?.message;
        this.schedulingMessage = serviceMessages.find((message) => message.page === 'scheduling')?.message;
      }
    },
    async updateServiceMessages() {
      const messages = [];
      if (this.globalServiceMessage) {
        messages.push({ message: this.globalServiceMessage });
      }

      if (this.schedulingMessage) {
        messages.push({
          message: this.schedulingMessage,
          page: 'scheduling',
        });
      }

      const response = await DataService.updateServiceMessages(messages);
      return response.status === 200;
    },

    hasConfigChanges() {
      return JSON.stringify(this.form) !== JSON.stringify(this.originalForm);
    },

    async saveAll() {
      if (this.hasConfigChanges()) {
        this.warningDialog = true;
      } else {
        await this.proceedWithSave();
      }
    },

    async proceedWithSave() {
      this.warningDialog = false;
      
      let configSuccess = true;
      let messagesSuccess = true;
      
      if (this.hasConfigChanges()) {
        configSuccess = await this.updateClientInfo();
      }
      
      messagesSuccess = await this.updateServiceMessages();
      
      if (configSuccess && messagesSuccess) {
        Object.keys(this.unlockedSections).forEach(k => this.unlockedSections[k] = false);
        this.$root.$emit('raise_alert', {
          color: 'success',
          text: 'Your changes have been saved.',
        });
        if (this.hasConfigChanges()) {
          await this.getClientInfo();
        }
        await this.getServiceMessages();
      } else if (!configSuccess) {
        this.$root.$emit('raise_alert', {
          color: 'error',
          text: 'Unable to validate OpenDental API Key. Your changes could not be saved.',
        });
      } else {
        this.$root.$emit('raise_alert', {
          color: 'error',
          text: 'Failed to save service messages.',
        });
      }
    },
  },
  async mounted() {
    await Promise.all([
      this.getClientInfo(),
      this.getVersionInfo(),
      this.getServiceMessages(),
    ]);
  },
};
</script>
<style lang="scss" scoped>
@import '@/scss/variables.scss';

$lock-overlay-bg: rgba(245, 247, 250, 0.92);
$lock-overlay-border: #e2e8f0;
$lock-icon-color: #9ca3af;
$lock-label-color: #6b7280;

.loading-container {
  text-align: center;
  padding: 80px 24px;
}

.lockable-section {
  position: relative;

  &.is-locked {
    .fields-lockable {
      opacity: 0.75;
      pointer-events: none;
      user-select: none;
    }

    .section-lock-overlay {
      display: flex;
    }
  }

  .section-lock-overlay {
    display: none;
    position: absolute;
    inset: 0;
    background: $lock-overlay-bg;
    border-radius: 8px;
    border: 1px dashed $lock-overlay-border;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background $transition-fast $easing-smooth;
    z-index: 1;

    &:hover {
      background: rgba(235, 240, 246, 0.96);

      .section-lock-overlay__icon,
      .section-lock-overlay__label {
        color: #4b5563;
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      cursor: pointer;

      * { cursor: pointer; }
    }

    &__icon {
      color: $lock-icon-color;
      font-size: 28px;
      transition: color $transition-fast $easing-smooth;

      @media (max-width: $breakpoint-mobile) {
        font-size: 32px;
      }
    }

    &__label {
      color: $lock-label-color;
      font-size: 14px;
      font-weight: 500;
      transition: color $transition-fast $easing-smooth;

      @media (max-width: $breakpoint-mobile) {
        font-size: 16px;
      }
    }
  }
}
</style>
